import { cloneElement, type ReactNode } from 'react';

import type * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import { assertNever } from '@gitbook/util-ts';

import { SiteSectionGroupIcon } from '../SiteSectionGroupIcon';
import { SiteSectionIcon } from '../SiteSectionIcon';

export function SiteStructureItemList(props: {
    items: (api.SiteSectionGroup | api.SiteSection | api.SiteSpace)[];
    description?: ReactNode;
}) {
    const { items, description } = props;
    return (
        <div className="flex flex-col gap-2">
            {description ? <p>{description}</p> : null}
            <ul className="flex flex-col gap-2">
                {items.map((item) => {
                    const icon = (() => {
                        switch (item.object) {
                            case 'site-section-group':
                                return <SiteSectionGroupIcon siteSectionGroup={item} />;
                            case 'site-section':
                                return <SiteSectionIcon siteSection={item} />;
                            case 'site-space':
                                return <Icon.Documentation />;
                            default:
                                assertNever(item);
                        }
                    })();
                    return (
                        <li
                            key={item.id}
                            className="flex items-center gap-2 rounded border px-3 py-2"
                        >
                            {cloneElement(icon, { className: 'size-4 shrink-0 text-muted' })}
                            <span className="truncate">{item.title}</span>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
